import { createPolicyInstance } from './js/harden-policy-instance';
import { dispatchManagerReadyEvent } from './js/events';
import { ConsentPolicyManagerHeadless } from './js/consent-policy-manager-headless';

if (typeof window !== 'undefined') {
  const consentPolicyManager = new ConsentPolicyManagerHeadless();
  createPolicyInstance(consentPolicyManager);

  dispatchManagerReadyEvent()
}
